import { FC, ReactNode, useEffect } from 'react'
import { SideoverState } from '@/states'
import { COMPONENT_DEFAULT_ERRORS, COMPONENT_DEFAULT_FORM } from '@/data'

import {
    Header,
    Loading,
    Buttons,
    Forms
} from '@/ui/components'

const Sideover: FC = (): ReactNode => {
    const { Open, SetState, Mode, Loading: SlideoverLoading } = SideoverState()

    const HandleClose = () => {
        if (Mode === 'edit') SetState({
            Open: false,
            Loading: false,
            Mode: 'create',
            Form: COMPONENT_DEFAULT_FORM,
            Errors: COMPONENT_DEFAULT_ERRORS
        })

        else SetState({ Open: false })
    }

    useEffect(() => {
        const KeyPress = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && Open) {
                HandleClose()
            }
        }

        document.addEventListener('keydown', KeyPress)
        return () => document.removeEventListener('keydown', KeyPress)
    }, [Open])

    return (
        <section style={Open ? { width: '100%' } : { width: '0px', overflow: 'hidden' }} onClick={HandleClose} className='absolute top-0 bg-[#1818188a] overflow-hidden right-0 bottom-0 left-0 w-full h-screen flex justify-end z-30'>
            <div style={Open ? { width: '420px' } : { width: '0px', overflow: 'hidden' }} onClick={(e) => e.stopPropagation()} className='bg-[#262626] h-full border-[#424242] border-l relative transition-all ease-in-out duration-500'>
                <Loading />
                <Header />

                <div id='sideover-panel' className={`custom-scrollbar p-4 flex flex-col gap-1 h-full pb-[68px] ${SlideoverLoading ? 'pointer-events-none' : ''}`}>
                    <Forms />
                    <Buttons />
                </div>
            </div>
        </section>
    )
}

export default Sideover
